<template>
    <modal
    name="modal-product-reject"
    height="auto"
    width="20%"
    class="customSurveyModal"
    :scrollable="true"
    @before-open="beforeOpen"
    @closed="closed">

      <div class="row7">
        <header class="modalHeader flex flexAlignS">
          <div class="title">
            <p>반려 사유 작성</p>
          </div>
          <button @click="onClickCancel"></button>
        </header>
      </div>
      <div class="textareaContainer">
        <textarea name="" id="" cols="30" rows="10" placeholder="거절사유를 작성해주세요."></textarea>
      </div>
      <div class="modalFooterBtn btnBox">
        <button class="redBtn" @click="onClickSave">반 려</button>
        <button class="redborderBtn" @click="onClickCancel">취 소</button>
      </div>
      
    </modal>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'ModalProductReject',
  components: {
  },
  data(){
    return{
      modalResult: false,
      additionalItems: new Array(10)
    }
  },
  computed:{
  },
  mounted(){
    this.show()
  },
  methods:{
    ...mapActions('additionalItem', [
      'requestList',
      'save'
    ]),
    show(){
      this.$modal.show('modal-product-reject')
    },
    hide(){
      this.$modal.hide('modal-product-reject')
    },
    beforeOpen(){
      this.init()
    },
    closed(){
      this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
    },
    
    onClickSave(){
      this.save({
        type: 'PRODUCT', 
        list: this.additionalItems
      })
      .then((response)=>{
        if(response.status === 200){
          this.$alert('알림', '저장되었습니다.', '확인', {
            'closed': () => {
              this.modalResult = true
              this.hide()  
              //todo: 반려된 제품 신청한 기업또는 사용자에게 메일 자동 발송(반려된 템플릿도 필요)
            }
          })
        }
        else{
          this.$alert('알림', '데이터를 저장할 수 없습니다.')
        }
      })
      .catch(() =>{
        this.$alert('알림', '데이터 통신을 실패했습니다.')
      })
    },
    onClickCancel(){
      this.hide()
    }
  }
}
</script>
<style scoped>
  .customSurveyModal header button {background-size: auto; padding: 0 0rem;}
  .textareaContainer {width: 100%; text-align: center;}
  .textareaContainer textarea {width: 90%; text-align: center; font-size: 2.4rem; resize: none;}
</style>